import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarcoPageRoutingModule } from './marco-routing.module';
import { MarcoPage } from './marco.component';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CalendarModule } from 'primeng/calendar';
import { PlaceholderTableComponent } from '@components/placeholders/table/table.component';

@NgModule({
  declarations: [
    MarcoPage
  ],
  imports: [
    CommonModule,
    MarcoPageRoutingModule,
    BackboneComponent,
    HeaderPageTitleBoxComponent,
    PlaceholderTableComponent,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    RouterModule,
    InputSwitchModule,
    DropdownModule,
    CalendarModule
  ]
})

export class MarcoPageModule { }
